import { render } from "./employee-followups.vue?vue&type=template&id=24b5981e&scoped=true"
import script from "./employee-followups.vue?vue&type=script&lang=js"
export * from "./employee-followups.vue?vue&type=script&lang=js"

import "./employee-followups.vue?vue&type=style&index=0&id=24b5981e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b5981e"]])

export default __exports__